'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"suggestion__text":"Suggestion-module_suggestion__text__C7q8X","suggestion__text--bold":"Suggestion-module_suggestion__text--bold__xcAzV","suggestion__container":"Suggestion-module_suggestion__container__OkzvM"};

exports.default = styles;
//# sourceMappingURL=Suggestion.module.scss.js.map
